import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { FotoServiceResult, VoidFotoServiceResult } from "../interfaces/CarnetVirtual/FotoCarnetVirtual";
const wsBack: string = 'https://ws.espol.edu.ec/carnetvirtual/api/';
const APICATALOGO: string = 'fotoperfil';

export default class CarnetVirtualService {

    async GetFotoString(usuario:string): Promise<FotoServiceResult> {
        try {
            const response1: AxiosResponse<any> = await axios.get(wsBack + APICATALOGO + '/getfotoperfil?netid='+usuario+'&tipo_sistema=privados');
            //console.log(response1.data);        
            return response1.data;
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return  VoidFotoServiceResult();
        }
    }
}